import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72e91801"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "ms-auto" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "flex space-x-4 pb-5" }
const _hoisted_5 = { class: "mt-7 me-4 w-7/12" }
const _hoisted_6 = { class: "ms-4 w-5/12" }

import {onMounted, ref, computed} from "vue";
import {useRoute} from "vue-router";
import {getUserHistoriqueBlackList} from "@/_services/blackList/blacklist";
import {UserBlacklistComment, UserBlacklistHistorique} from "@/models/blacklisting/UserBlacklistHistorique";
import BlacklistingTable from "@/components/blacklisting/BlacklistingTable.vue";
import UserProfilTable from "@/components/blacklisting/UserProfilTable.vue";
import BlacklistingCommentTable from "@/components/blacklisting/BlacklistingCommentTable.vue";
import Tag from "primevue/tag";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserBlacklistHistorique',
  setup(__props) {

const route = useRoute();
const params = computed(() => route.params);
const isLoading = ref(true);
let savedTable: UserBlacklistComment[] = [];
const title = ref<string>("");
const usersBlackListUuid = Array.isArray(params.value.uuid) ? params.value.uuid.join(",") : params.value.uuid;
const historiqueBlacklist = ref<UserBlacklistHistorique>({} as UserBlacklistHistorique);

onMounted(async () => {
    const [isLoadingDt, historiqueBlacklistData] = await getUserHistoriqueBlackList(usersBlackListUuid);
    title.value = `Historique Blacklisting de ${historiqueBlacklistData.user.firstname} ${historiqueBlacklistData.user.lastname}`;
    isLoading.value = isLoadingDt;
    historiqueBlacklist.value = historiqueBlacklistData;
    savedTable = historiqueBlacklist.value.comments;
    historiqueBlacklist.value.blacklists = historiqueBlacklist.value.blacklists.reverse();
});

let filtered = false;
let lastIndex = "";
const filterCommentTableByReason = (index: string) => {
    if (!filtered || (filtered && lastIndex !== index)) {
        historiqueBlacklist.value.comments = filterTableByUuid(savedTable, index);
        filtered = true;
        lastIndex = index;
    } else if (filtered) {
        historiqueBlacklist.value.comments = savedTable;
        filtered = false;
        lastIndex = index;
    } else {
        historiqueBlacklist.value.comments = filterTableByUuid(historiqueBlacklist.value.comments, index);
        filtered = true;
        lastIndex = index;
    }
};

function filterTableByUuid(table: UserBlacklistComment[], uuid: string): UserBlacklistComment[] {
    return table.filter((item: UserBlacklistComment) => item.uuid === uuid);
}

return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(title.value), 1),
          _createVNode(_unref(Tag), {
            severity: historiqueBlacklist.value.active ? 'danger' : 'success',
            value: historiqueBlacklist.value.active ? 'Blacklisté' : 'Whitelisté',
            class: "mx-3",
            rounded: ""
          }, null, 8, ["severity", "value"]),
          _createElementVNode("span", null, _toDisplayString(historiqueBlacklist.value.active ? 'Non traité' : 'Traité'), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(BlacklistingTable, {
              data: historiqueBlacklist.value.blacklists,
              onFilterCommentsByReason: filterCommentTableByReason
            }, null, 8, ["data"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(UserProfilTable, { data: historiqueBlacklist.value }, null, 8, ["data"])
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(BlacklistingCommentTable, {
            data: historiqueBlacklist.value.comments
          }, null, 8, ["data"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})